<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div :class="['pad-head', { 'pad-head-fixed': state.padHeadFixed }]">
    <div :class="['status-bar', { 'dark-mode': $route.meta.darkMode }]">
      <div class="pad-name">智能印控仪</div>

      <div class="status-bar-content">
        <div class="left-status">
          <div class="wifi">
            <img class="network-icon" v-show="state.networkIcon" :src="state.networkIcon" alt="">
          </div>
          <div class="usb" v-show="state.showUsbIcon">
            <img class="usb-icon" :src="useIcon" alt="">
          </div>
        </div>
        <div class="right-status">
          <div class="battery">
            <img class="battery-icon" v-show="state.batteryIcon" :src="state.batteryIcon" alt="">
            <div class="battery-level">{{ state.batteryLevel }}</div>
          </div>
        </div>
        <div class="time">{{ state.time }}</div>
      </div>


    </div>
    <div class="pad-head-content" v-show="!state.padHeadHidden">
      <div class="pad-head-left">
        <div class="back" @click="back">
          <i class="iconfont icon-gaopaiyifanhuitubiao"></i>
        </div>
        <div class="pad-custom-head-slot"></div>
      </div>
      <div class="pad-head-center" v-show="!state.padHiddenTitle">
        <div class="title">{{ state.title }}</div>
      </div>
      <div class="pad-head-right"></div>
    </div>
  </div>
</template>
<script setup>
import { useRouter, useRoute } from 'vue-router'
import { onMounted, reactive, computed, watch, onBeforeUnmount } from 'vue'
import { throttle } from 'lodash';
import { GLOBAL_ENUM, DATA } from '@/utils/yky'
import { usePageResizeStore } from '@/store/pageResize'
import { HEAD_EVENT_TYPE, useHeadStore } from '@/store/home'
import { xda } from '@hybird/flutter'
import {getDeviceInfo} from '@/utils/env'
import ethernet from '@/assets/images/ykyhead/ethernet.png'
import mobile from '@/assets/images/ykyhead/mobile.png'
import wifi0 from '@/assets/images/ykyhead/wifi0.png'
import wifi1 from '@/assets/images/ykyhead/wifi1.png'
import wifi2 from '@/assets/images/ykyhead/wifi2.png'
import wifi3 from '@/assets/images/ykyhead/wifi3.png'
import discharging_0 from '@/assets/images/ykyhead/discharging_0.png'
import discharging_1 from '@/assets/images/ykyhead/discharging_1.png'
import discharging_2 from '@/assets/images/ykyhead/discharging_2.png'
import discharging_3 from '@/assets/images/ykyhead/discharging_3.png'
import charging_0 from '@/assets/images/ykyhead/charging_0.png'
import charging_1 from '@/assets/images/ykyhead/charging_1.png'
import charging_2 from '@/assets/images/ykyhead/charging_2.png'
import charging_3 from '@/assets/images/ykyhead/charging_3.png'
import useIcon from '@/assets/images/ykyhead/usb.png'

const pageResizeStore = usePageResizeStore()
const isResizeMobile = computed(() => pageResizeStore.isMobile)
const router = useRouter()
const route = useRoute()
const headStore = useHeadStore()

const SIGNAL_LEVELS = [
  { threshold: -25, index: 3 }, // Very Good
  { threshold: -50, index: 2 }, // Okay
  { threshold: -75, index: 1 }, // Not Good
  { threshold: -100, index: 0 }, // Unusable
]

const BATTERY_LEVELS = [
  { threshold: 100, index: 3 }, // Unusable
  { threshold: 75, index: 2 }, // Not Good
  { threshold: 50, index: 1 }, // Okay
  { threshold: 25, index: 0 }, // Very Good
]

const BATTERY_STATE_ICON_KEY = {
  /// The battery is completely full of energy.
  full: 'charging_icon',
  /// The battery is currently storing energy.
  charging: 'charging_icon',
  /// The battery is currently losing energy.
  discharging: 'discharging_icon',
  /// The state of the battery is unknown.
  unknown: 'battery-unknown'
}

const USB_DEVICE_STATE = {
  /// Event passed to usbEventStream when a USB device is attached.
  ACTION_USB_ATTACHED: 'android.hardware.usb.action.USB_DEVICE_ATTACHED',
  /// Event passed to usbEventStream when a USB device is detached.
  ACTION_USB_DETACHED: 'android.hardware.usb.action.USB_DEVICE_DETACHED'
}

const wifi_level_icon = {
  0: wifi0,
  1: wifi1,
  2: wifi2,
  3: wifi3,
}

const battery_icon = {
  charging_icon: {
    0: charging_0,
    1: charging_1,
    2: charging_2,
    3: charging_3,
  },
  discharging_icon: {
    0: discharging_0,
    1: discharging_1,
    2: discharging_2,
    3: discharging_3,
  },
}

const state = reactive({
  time: '',
  padHiddenTitle: false,
  padHeadHidden: true,
  padHeadFixed: false,
  title: '',
  networkIcon: '',
  batteryIcon: '',
  batteryLevel: '',
  showUsbIcon: false,
})

const networkStatus = {
  'ethernet': () => ethernet,
  'wifi': () => getWifiIcon(),
  'mobile': () => mobile
}

const getDate = () => {
  const now = new Date()
  const hours = now.getHours() // 小时 (0-23)
  const minutes = now.getMinutes() // 分钟 (0-59)

  state.time = `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes
    }`
}

const back = () => {
  router.back()
}

const isExternalDevice = (device) => {
  const { vid, pid, manufacturerName } = device
  //扫描仪、有线（天玺|smart）
  return manufacturerName == 'EPSON' || (vid == 1317 && pid == 42151) || (vid == 8711 && pid == 25)
}

const getWifiIcon = async (level) => {
  const wifiInfo = await xda?.getCurrWifiInfo()
  console.log('wifiInfo', wifiInfo ? JSON.stringify(wifiInfo) : wifiInfo)
  const currentSignalStrength = wifiInfo?.currentSignalStrength || -100
  const signalLevel = SIGNAL_LEVELS.find(item => currentSignalStrength >= item.threshold)?.index || 0
  return wifi_level_icon[signalLevel] || wifi0
}

const handleConnectivityChange = async (params) => {
  const status = params.status[0]
  state.networkIcon = await networkStatus[status]?.(params.status[1]) || ''
  console.log('设置网络图标', status, state.networkIcon)
}

const handleBatteryStatus = (params) => {
  const { status: batteryState, battery } = params
  const batteryLevel = BATTERY_LEVELS.find(item => battery >= item.threshold)?.index || 0
  const batteryStateIconKey = BATTERY_STATE_ICON_KEY[batteryState] || BATTERY_STATE_ICON_KEY.unknown
  const icon = batteryStateIconKey == BATTERY_STATE_ICON_KEY.unknown ? '' : battery_icon[batteryStateIconKey][batteryLevel] || ''
  state.batteryIcon = icon
  state.batteryLevel = `${battery}%`
}

const handleUsbDeviceStateChange = async (params) => {
  const usbDevices = await xda?.usbDevices()
  console.log('USB设备', usbDevices)
  if (Array.isArray(usbDevices)) {
    state.showUsbIcon = usbDevices.some(item => isExternalDevice(item));
  } else {
    state.showUsbIcon = false
  }
}

const throttledHandleBatteryStatus = throttle((params) => {
  console.log("onBattery", JSON.stringify(params));
}, 2000)

const listenHeadStatus = () => {
  const deviceInfo = getDeviceInfo()
  //电量
  xda?.onBattery(params => {
    //三代需要充电才能使用特殊处理状态
    if(deviceInfo?.device.type == 5) params.status = 'full'
    throttledHandleBatteryStatus(params)
    handleBatteryStatus(params)
  })

  //进来先获取一次
  xda?.checkConnectivity().then(res => {
    console.log('获取网络状态', res)
    handleConnectivityChange({ status: res })
  })

  //网络状态
  xda?.onConnectivityChange((params) => {
    console.log("onConnectivityChange", params)
    handleConnectivityChange(params)
  })

  //先获取一次USB设备(更新页面)
  handleUsbDeviceStateChange()

  xda?.onUsbDeviceStateChange((params) => {
    console.log('USB设备状态变化', JSON.stringify(params))
    handleUsbDeviceStateChange(params)
  })

  console.log('监听电量和网络状态', xda)
}

const listenHeadNotice = () => {
  headStore.addEventListener(HEAD_EVENT_TYPE.SET_HEAD_HIDE, (val) => {
    state.padHeadHidden = val
  })

  headStore.addEventListener(HEAD_EVENT_TYPE.SET_HEAD_TITLE, (val) => {
    console.log('设置头部标题', val)
    state.title = val
  })
}

onMounted(() => {
  setInterval(() => {
    getDate()
  }, 1000)
  listenHeadNotice()
  listenHeadStatus()
})

onBeforeUnmount(() => {
  // xda?.offBattery()
  // xda?.offConnectivityChange()
  // xda?.offUsbDeviceStateChange()
})

watch(
  () => route.path,
  (newVal, oldVal) => {
    if (newVal != oldVal) {
      document.body.style.background =
        route.meta.bodyBackground && !isResizeMobile.value
          ? DATA.THEME_BACKGROUND_COLOR[route.meta.bodyBackground]
          : DATA.THEME_BACKGROUND_COLOR[GLOBAL_ENUM.THEME_TYPE.DEFAULT_THEME]

      if (!isResizeMobile.value && route.meta.darkMode) {
        document.body.style.background = 'black'
      }

      state.padHeadFixed = !!route.meta.padHeadFixed
      state.padHeadHidden = !!route.meta.padHeadHidden
      state.padHiddenTitle = !!route.meta.padHiddenTitle
      state.title = route.meta.title
      console.log('设置头部标题2', route.meta.title, state.padHeadHidden, state.padHeadHidden, route.meta.bodyBackground)
    }
  }
)

watch(() => pageResizeStore.isMobile, () => {
  document.body.style.background =
    route.meta.bodyBackground && !isResizeMobile.value
      ? DATA.THEME_BACKGROUND_COLOR[route.meta.bodyBackground]
      : DATA.THEME_BACKGROUND_COLOR[GLOBAL_ENUM.THEME_TYPE.DEFAULT_THEME]

  state.padHeadFixed = !!route.meta.padHeadFixed
  state.padHeadHidden = !!route.meta.padHeadHidden
  state.padHiddenTitle = !!route.meta.padHiddenTitle
  state.title = route.meta.title

  console.log('头部监听到页面变化', route.meta.title, state.padHeadHidden, state.padHeadHidden)
}, {
  immediate: true
})


const getBattery = () => {
  xda?.getBattery().then(res => {
    console.log('获取电量', res)
    // handleBatteryStatus(res)
  })
}

</script>
<style lang="less" scoped>
@import url('./index.less');
</style>
